import { routeForStep, useOnboarding } from "@/hooks/use-onboarding";
import { useShowOnboarding } from "@/hooks/use-show-onboarding";
import type { FC } from "react";
import { Navigate } from "react-router-dom";

/**
 * Backwards compatibility with the old URLs
 * Ensures that any client on /onboarding/enabler is redirected to the correct url
 */
export const OnboardingRedirect: FC = () => {
    const onboarding = useOnboarding();
    const showOnboarding = useShowOnboarding();
    let to = routeForStep(onboarding.steps.defaultActive);

    if (onboarding.steps.isLoading) {
        return;
    }

    if (!showOnboarding) {
        to = "/projects";
    }

    return <Navigate to={to} replace />;
};
